import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RedirectGuard = props => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    // The requested URL, including its query, wins over old unload snapshots.
    sessionStorage.removeItem("currentPage");
    let redirectToMain = null;
    try {
      redirectToMain = JSON.parse(localStorage.getItem("redirectToMainOnError"));
    } catch (e) {
      localStorage.removeItem("redirectToMainOnError");
    }
    if (!redirectToMain) return;
    if (redirectToMain.url !== pathname || redirectToMain.count >= 2) {
      localStorage.removeItem("redirectToMainOnError");
    }
    if (redirectToMain.url === pathname && redirectToMain.count >= 2) {
      navigate("/office/global", { replace: true });
    }
  }, [navigate, pathname]);

  return (
    <React.Fragment>
        {props.children}
    </React.Fragment>
  )
};

export default RedirectGuard;
